module.exports = __webpack_public_path__ + "static/media/hero-shadow.3db97a6d.svg";